import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import withStyles from '@mui/styles/withStyles';
import styles from '../styles';
import { addContact } from '../../store/contacts.actions';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Button } from '@mui/material';
import ContactForm from './ContactForm';
import { Formik } from 'formik';

// FIXME checkout https://mui.com/components/use-media-query/#using-material-uis-breakpoint-helpers
const withMobileDialog = () => WrappedComponent => props => (
  <WrappedComponent {...props} width="lg" fullScreen={false} />
);

class ContactCreateDialog extends Component {
  handleCreateClick = () => {
    const { onConfirm } = this.props;
    onConfirm?.();
  };

  handleCancelClick = () => {
    const { onCancel } = this.props;
    onCancel?.();
  };

  handleSubmit = async (values, actions) => {
    const { addContact } = this.props;
    try {
      await addContact(values);
      actions.setSubmitting(false);
      this.handleCreateClick();
    } catch (e) {
      actions.setSubmitting(false);
    }
  };

  render() {
    const { fullScreen, open, classes, t } = this.props;
    return (
      <Formik
        initialValues={{
          name: null,
          position: null,
          phone: null,
          email: null,
        }}
        onSubmit={this.handleSubmit}
      >
        {({ submitForm, values, errors, touched }) => (
          <Dialog open={open} fullScreen={fullScreen} fullWidth maxWidth="xs">
            <DialogTitle>{t('Create_Contact')}</DialogTitle>
            <DialogContent className={classes.noPadding}>
              {/*{false && <TextField placeholder="Search" />}*/}
              <ContactForm values={values} errors={errors} touched={touched} />
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={this.handleCancelClick}>
                {t('Cancel')}
              </Button>
              <Button
                color="primary"
                onClick={submitForm}
                // disabled={!dirty}
              >
                {t('Create')}
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Formik>
    );
  }
}

const mapDispatchToProps = {
  addContact,
};

const mapStateToProps = () => ({});

export default withTranslation()(withStyles(styles)(
  withMobileDialog()(
    connect(mapStateToProps, mapDispatchToProps)(ContactCreateDialog)
  )
));
